import '../../components/styles/PharmacovigilanceCommittee.css';
import '../../components/styles/CommitteeTable.css';

const HospitalInfection = () => {
  const members = [
    { sl: 1, name: 'Dr. Prasath. C', designation: 'Medical Superintendent', position: 'Chairperson' },
    { sl: 2, name: 'Dr. Kumaraguru', designation: 'Senior Resident', position: 'Member Secretary' },
    { sl: 3, name: 'Dr. Ramya. G', designation: 'Lab Director, Central Diagnostic Laboratory', position: 'Member' },
    { sl: 4, name: 'Dr. Saleem. M', designation: 'Professor & Head Microbiology', position: 'Member' },
    { sl: 5, name: 'Dr. Shanmuga Vadivel', designation: 'Professor & Head Dentistry', position: 'Member' },
    { sl: 6, name: 'Dr. Mubeen Mohammed', designation: 'Assistant Professor of Anaesthesiology', position: 'Member' },
    { sl: 7, name: 'Dr. Vimal Kumar', designation: 'Senior Resident of General Medicine', position: 'Member' },
    { sl: 8, name: 'Dr. Sangeetha', designation: 'Senior Resident of OBG', position: 'Member' },
    { sl: 9, name: 'Dr. Rabiyathul Bazeeria S', designation: 'Senior Resident of ENT', position: 'Member' },
    { sl: 10, name: 'Dr. Aravinda Raj. G', designation: 'Senior Resident of Orthopaedics', position: 'Member' },
    { sl: 11, name: 'Mrs. Glory', designation: 'Nursing Superintendent', position: 'Member' },
    { sl: 12, name: 'Mr. Sathia Rajesh', designation: 'Technical Manager, Central Diagnostic Laboratory', position: 'Member' },
    { sl: 13, name: 'Ms. Rajeswari', designation: 'OT&CSSD – Nursing Supervisor', position: 'Member' },
    { sl: 14, name: 'Ms. Rajeswai', designation: '', position: 'Infection Prevention Control Nurse' },
    { sl: 15, name: 'Mr. Jayakuamar', designation: 'Senior Operations Executive', position: 'Member' },
    { sl: 16, name: 'Mr. Rajendran', designation: 'Kitchen Incharge', position: 'Member' },
    { sl: 17, name: 'Mr. Dinesh', designation: 'Laundry Incharge', position: 'Member' },
  ];

  const pdfPath = '/assets/document/committee/hospital-infection/Hospital infection control committee.pdf';

  return (
    <div className="pharma-container">
      <header className="pharma-header">
        <h1>Hospital Infection Control Committee</h1>
      </header>

      <section className="pharma-description">
        <p>
          The Hospital Infection Control Committee (HICC) plays a vital role in maintaining hygiene,
          controlling infection outbreaks, and ensuring a safe hospital environment. It implements
          and monitors infection control practices to safeguard both patients and healthcare workers.
        </p>
      </section>

      <section className="pharma-table-section">
        <div className="ct-table-wrapper">
          <table className="pharma-table ct-table">
            <thead>
              <tr>
                <th>Sl. No.</th>
                <th>Name</th>
                <th>Designation</th>
                <th>Position</th>
              </tr>
            </thead>
            <tbody>
              {members.map((m) => (
                <tr key={m.sl}>
                  <td className="ct-sl" data-label="Sl.">{m.sl}</td>
                  <td data-label="Name">{m.name}</td>
                  <td data-label="Designation">{m.designation}</td>
                  <td data-label="Position">{m.position}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <div className="ct-doc-btn-wrap">
        <a href={`/view-document.html?file=${encodeURIComponent(pdfPath)}`} target="_blank" rel="noopener noreferrer" className="ct-doc-btn">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="12" y1="18" x2="12" y2="12"/>
            <line x1="9" y1="15" x2="15" y2="15"/>
          </svg>
          View Official Document
        </a>
      </div>
    </div>
  );
};

export default HospitalInfection;
